// w = relevance weights (need/desire), s = existing strengths, f = sequencing flags
const o = (label, w = {}, s = {}, f = []) => ({ label, w, s, f });

const FREQ = ["Rarely or never", "Occasionally", "Sometimes", "Often", "Almost always"];
const FREQ_POS = ["Rarely or never", "A few times a month", "Weekly", "Several times a week", "Daily"];
const CONF = ["Not yet confident", "A little confident", "Somewhat confident", "Quite confident", "Deeply confident"];

const scale = (labels, w = {}, s = {}, f = {}) =>
  labels.map((label, i) => ({
    label,
    w: Object.fromEntries(Object.entries(w).map(([k, v]) => [k, v[i]])),
    s: Object.fromEntries(Object.entries(s).map(([k, v]) => [k, v[i]])),
    f: f[i] || [],
  }));

export const QUESTIONS = [
  { id: "q1", theme: "Body & Energy", type: "single", prompt: "How do you typically feel in your body throughout the day?", options: [
    o("Tense, tired, or running on empty", { EM: 3, RN: 2 }, {}, ["overwhelm"]),
    o("Disconnected, as if I live mostly in my head", { EM: 2, FM: 2, DF: 1 }, {}, ["disconnected"]),
    o("Up and down, depending on the day", { EM: 1, RR: 1, RN: 1 }),
    o("Mostly grounded and at ease", {}, { EM: 2, FM: 1 }),
    o("Vibrant, sensual, and alive", { SW: 1, GW: 1 }, { EM: 2, SW: 1 }),
  ]},
  { id: "q2", theme: "Body & Energy", type: "single", prompt: "What usually happens when you are stressed or overwhelmed?", options: [
    o("I push through and keep doing", { DF: 3, EM: 1, RN: 1 }, {}, ["overdoing"]),
    o("I shut down or go numb", { EM: 3 }, {}, ["overwhelm", "disconnected"]),
    o("I feel drained, like I'm absorbing everyone else's emotions", { PR: 3, EM: 2 }, {}, ["lowBoundaries"]),
    o("I spiral into worry about what might go wrong", { ID: 2, CE: 2, EM: 1 }),
    o("I have practices that bring me back to center", { RR: 1 }, { EM: 2, RR: 1 }),
  ]},
  { id: "q3", theme: "Body & Energy", type: "scale", prompt: "How often do you feel exhausted, depleted, or overwhelmed?", help: "Frequency",
    options: scale(FREQ, { EM: [0, 1, 2, 3, 3], RN: [0, 1, 1, 2, 3] }, { EM: [2, 1, 0, 0, 0] }, { 3: ["overwhelm"], 4: ["overwhelm"] }) },
  { id: "q4", theme: "Womb & Feminine", type: "single", prompt: "How connected do you feel to your womb or pelvic center?", help: "Every body is honored here, including women who have experienced hysterectomy.", options: [
    o("I rarely think about it or feel disconnected", { WB: 3 }, {}, ["wombDisconnect"]),
    o("Curious, but unsure where to begin", { WB: 3 }),
    o("Somewhat connected, and I'd love to deepen it", { WB: 2, SW: 1 }),
    o("Deeply connected; it's a source of wisdom for me", { WB: 1 }, { WB: 3 }),
    o("I've had a hysterectomy and would love to honor my womb space energetically", { WB: 3 }),
    o("I'd prefer not to focus here right now", {}),
  ]},
  { id: "q5", theme: "Womb & Feminine", type: "single", prompt: "How comfortable are you receiving support and allowing yourself to rest?", options: [
    o("Very uncomfortable; I'd rather do it myself", { DF: 3, RN: 2 }, {}, ["overdoing"]),
    o("I accept help, but I feel guilty resting", { DF: 2, RN: 3 }),
    o("I'm getting better; it's a work in progress", { DF: 1, RN: 1 }),
    o("I receive easily and rest without guilt", {}, { DF: 2, RN: 2 }),
  ]},
  { id: "q6", theme: "Womb & Feminine", type: "scale", prompt: "How connected do you feel to your sensuality and personal pleasure?", help: "Connection",
    options: scale(["Not connected", "Slightly", "Somewhat", "Quite connected", "Deeply connected"], { SW: [3, 3, 2, 1, 0] }, { SW: [0, 0, 0, 1, 3] }) },
  { id: "q7", theme: "Desires", type: "multi", max: 3, prompt: "Which of these would you love more of in your life?", help: "Choose up to three.", options: [
    o("Softness and ease", { DF: 2, RN: 1 }),
    o("Pleasure and sensual delight", { SW: 3 }, {}, ["desireSensual"]),
    o("Feeling at home in my body", { EM: 2, FM: 2 }),
    o("A deeper bond with my womb and creative energy", { WB: 3 }),
    o("Magick and meaningful ritual", { CM: 3, RR: 1 }),
    o("Clear intuitive guidance", { IN: 3 }),
    o("Confidence that my intentions become reality", { GC: 2, EA: 2 }),
    o("Beauty, wonder, and play", { GW: 3 }),
    o("Nourishing food and vibrant energy", { RV: 2, JS: 2 }),
  ]},
  { id: "q8", theme: "Womb & Feminine", type: "single", prompt: "How would you describe your relationship with your feminine and masculine energies?", options: [
    o("I live mostly in doing, achieving, and pushing", { DF: 3 }, {}, ["overdoing"]),
    o("I'm drawn to softness but don't fully trust it yet", { DF: 2, EM: 1 }),
    o("I move between both and want more intention", { DF: 2 }),
    o("I feel a beautiful, fluid balance", {}, { DF: 3 }),
  ]},
  { id: "q9", theme: "Womb & Feminine", type: "scale", prompt: "How often do you do something purely for your own pleasure or devotion?", help: "Frequency",
    options: scale(FREQ_POS, { SW: [3, 2, 1, 0, 0], GW: [2, 1, 1, 0, 0] }, { SW: [0, 0, 0, 1, 2] }) },
  { id: "q10", theme: "Spiritual Energy", type: "scale", prompt: "How confident are you in establishing personal and energetic boundaries?", help: "Confidence",
    options: scale(CONF, { PR: [3, 3, 2, 1, 0] }, { PR: [0, 0, 0, 2, 3] }, { 0: ["lowBoundaries"], 1: ["lowBoundaries"] }) },
  { id: "q11", theme: "Spiritual Energy", type: "scale", prompt: "How often do you cleanse or clear your energy or your space?", help: "Frequency",
    options: scale(FREQ_POS, { PR: [2, 2, 1, 0, 0], SE: [1, 1, 0, 0, 0] }, { PR: [0, 0, 1, 2, 2] }) },
  { id: "q12", theme: "Spiritual Energy", type: "scale", prompt: "How often do you notice intuitive impressions such as gut feelings, images, or an inner knowing?", help: "Frequency",
    options: scale(FREQ, { IN: [1, 2, 3, 2, 1], GF: [0, 0, 1, 2, 3] }, { IN: [0, 0, 0, 1, 2] }) },
  { id: "q13", theme: "Spiritual Energy", type: "multi", prompt: "Which spiritual practices are already part of your life?", help: "Select all that apply.", options: [
    o("Meditation or prayer", { IN: 1 }, { RR: 1, IN: 1 }),
    o("Candle work or rituals", { GF: 1, CM: 1 }, { CM: 2 }, ["practitioner"]),
    o("Tarot, oracle, or divination", { GF: 1, IN: 1 }, { IN: 2 }, ["practitioner"]),
    o("Energy healing such as Reiki", { GF: 1 }, { EM: 2 }),
    o("Crystals, herbs, or plant allies", { HB: 1 }, { HB: 1 }),
    o("Manifestation or scripting", { GC: 1 }, { GC: 1, EA: 1 }),
    o("Affirmations or mindset work", { ID: 1 }, { ID: 1 }),
    o("Not yet; I'm just beginning", { PR: 1, IN: 1, CE: 1 }, {}, ["beginner"]),
  ]},
  { id: "q14", theme: "Spiritual Energy", type: "single", prompt: "When you imagine deepening your spiritual practice, what calls to you most?", options: [
    o("Protecting my energy and feeling spiritually safe", { PR: 3 }),
    o("Candle magick, spellwork, and creating rituals", { CM: 3 }, {}, ["wantsAdvanced"]),
    o("Understanding my intuitive senses", { IN: 3 }),
    o("Using my gifts with confidence in daily life and service", { GF: 3 }),
    o("I'd rather focus on other areas right now", {}),
  ]},
  { id: "q15", theme: "Spiritual Energy", type: "scale", prompt: "How confident are you interpreting the intuitive messages you receive?", help: "Confidence",
    options: scale(CONF, { IN: [2, 3, 2, 1, 0], GF: [0, 1, 2, 3, 2] }, { IN: [0, 0, 0, 2, 3] }) },
  { id: "q16", theme: "Spiritual Energy", type: "single", prompt: "How do you feel about your spiritual gifts?", options: [
    o("I'm not sure I have any yet", { IN: 2, GF: 1, CE: 1 }),
    o("I sense them, but they feel unpredictable", { IN: 2, GF: 2, PR: 1 }),
    o("I know my gifts and want to develop them", { GF: 3, IN: 1 }),
    o("I use them regularly and want to apply them in service", { GF: 3 }, { IN: 2 }),
    o("They're not a focus for me right now", {}),
  ]},
  { id: "q17", theme: "Spiritual Energy", type: "single", prompt: "When you encounter heavy energy, like a tense room or a draining person, what happens?", options: [
    o("I absorb it and carry it for hours or days", { PR: 3, EM: 2 }, {}, ["lowBoundaries"]),
    o("I notice it but don't know how to clear it", { PR: 3 }),
    o("I protect myself some of the time", { PR: 1 }, { PR: 1 }),
    o("I ground, shield, and release it with ease", {}, { PR: 3 }),
  ]},
  { id: "q18", theme: "Reality Creation", type: "single", prompt: "When you desire something, how do you typically approach creating it?", options: [
    o("I wish and hope, but mostly wait", { CE: 3, EA: 2 }),
    o("I set intentions, but doubt they'll happen", { ID: 3 }, {}, ["limitingBeliefs"]),
    o("I work very hard to force it into being", { DF: 2, EA: 2 }, {}, ["overdoing"]),
    o("I visualize clearly, but struggle to take consistent action", { EA: 3 }, {}, ["intentNoAction"]),
    o("I align my identity, act, and watch it unfold", { GC: 2 }, { ID: 2, EA: 2 }),
  ]},
  { id: "q19", theme: "Reality Creation", type: "scale", prompt: "How aware are you of the beliefs shaping your decisions?", help: "Awareness",
    options: scale(["Not yet aware", "Slightly aware", "Somewhat aware", "Quite aware", "Deeply aware"], { ID: [3, 3, 2, 1, 0], CE: [2, 2, 1, 0, 0] }, { ID: [0, 0, 0, 1, 2] }) },
  { id: "q20", theme: "Reality Creation", type: "scale", prompt: "How consistently do your actions reflect the reality you desire?", help: "Consistency",
    options: scale(FREQ, { EA: [3, 3, 2, 1, 0], ED: [1, 1, 1, 0, 0] }, { EA: [0, 0, 0, 2, 3] }) },
  { id: "q21", theme: "Reality Creation", type: "single", prompt: "Which inner story would you most love to rewrite?", options: [
    o("\"I'm not enough\" or \"Who am I to have that?\"", { ID: 3 }, {}, ["limitingBeliefs"]),
    o("\"Good things don't last for me\"", { ID: 2, CE: 2 }),
    o("\"I have to work hard for everything\"", { DF: 2, ID: 1, CE: 1 }),
    o("\"I don't know what I truly want\"", { CE: 3 }),
    o("My inner stories feel largely supportive", { GC: 1 }, { ID: 2 }),
  ]},
  { id: "q22", theme: "Reality Creation", type: "multi", max: 3, prompt: "Which creation tools intrigue you most?", help: "Choose up to three.", options: [
    o("Number, word, phrase, or sound codes", { GC: 3 }),
    o("Revision: lovingly rewriting past memories", { ID: 3 }),
    o("Expanding my awareness and perception", { CE: 3 }),
    o("Daily manifestation rituals", { EA: 2, RR: 1 }),
    o("Living as if it's already done", { EA: 3 }),
    o("Sensing energy and intuitive impressions", { IN: 2 }),
    o("None of these intrigue me right now", {}),
  ]},
  { id: "q23", theme: "Reality Creation", type: "scale", prompt: "How often do you notice your habitual thoughts and question whether they are true?", help: "Frequency",
    options: scale(FREQ, { CE: [3, 2, 1, 0, 0] }, { CE: [0, 0, 0, 1, 2] }) },
  { id: "q24", theme: "Reality Creation", type: "single", prompt: "How do you feel about using codes such as numbers, words, phrases, or sounds to support your intentions?", options: [
    o("Brand new to me, and fascinating", { GC: 3 }),
    o("I use them occasionally", { GC: 2 }),
    o("They're a core part of my practice", { GC: 2 }, { GC: 2 }),
    o("I'm not drawn to them right now", {}),
  ]},
  { id: "q25", theme: "Goddess Lifestyle", type: "single", prompt: "How do your mornings and evenings usually unfold?", options: [
    o("Rushed; I wake up already behind", { RR: 3, RN: 1 }, {}, ["unsupportiveLifestyle"]),
    o("Scattered, with no real rhythm", { RR: 3, ED: 1 }, {}, ["unsupportiveLifestyle"]),
    o("I have a few habits I'd love to make sacred", { RR: 2 }),
    o("I have nourishing rituals I love", {}, { RR: 3 }),
  ]},
  { id: "q26", theme: "Goddess Lifestyle", type: "scale", prompt: "How supportive is your home environment?", help: "Support",
    options: scale(["Draining", "Unsupportive", "Neutral", "Supportive", "A true sanctuary"], { SE: [3, 3, 2, 1, 0], NL: [2, 2, 2, 1, 1] }, { SE: [0, 0, 0, 2, 3] }, { 0: ["unsupportiveLifestyle"], 1: ["unsupportiveLifestyle"] }) },
  { id: "q27", theme: "Goddess Lifestyle", type: "single", prompt: "How intentionally do you nourish yourself?", options: [
    o("I eat on the run and often skip meals", { RV: 2, JS: 2, RN: 1 }, {}, ["unsupportiveLifestyle"]),
    o("I eat okay, but want more fresh, living food", { RV: 3, JS: 2 }),
    o("I'd love to explore plant-based and raw recipes", { RV: 3, JS: 1 }),
    o("I love fresh juices and smoothies and want to go deeper", { JS: 3 }),
    o("I nourish myself with care and intention", { HB: 1 }, { RV: 1, JS: 1 }),
  ]},
  { id: "q28", theme: "Goddess Lifestyle", type: "multi", max: 3, prompt: "Which lifestyle practices would you most enjoy developing?", help: "Choose up to three.", options: [
    o("Raw vegan meals", { RV: 3 }),
    o("Juicing and smoothies", { JS: 3 }),
    o("Herbal teas and growing herbs", { HB: 3 }),
    o("Yoga, dance, and feminine movement", { FM: 3 }),
    o("Creating a sanctuary at home", { SE: 3 }),
    o("Natural fabrics, linen, and curated decor", { NL: 3 }),
    o("Sacred morning and evening routines", { RR: 3 }),
    o("Conscious family rituals with children", { HC: 3 }),
    o("Whimsy, wonder, and beautiful play", { GW: 3 }),
    o("Restful, replenishing rhythms", { RN: 3 }),
  ]},
  { id: "q29", theme: "Goddess Lifestyle", type: "scale", prompt: "How often do you move your body in ways that feel good, never as punishment?", help: "Frequency",
    options: scale(FREQ_POS, { FM: [3, 3, 2, 1, 0], EM: [1, 1, 0, 0, 0] }, { FM: [0, 0, 0, 2, 3] }) },
  { id: "q30", theme: "Goddess Lifestyle", type: "single", prompt: "Do children play a role in your daily life?", options: [
    o("Yes, I'm raising children and want a more conscious, high-frequency home", { HC: 3, ED: 1 }),
    o("Yes, as a caregiver, auntie, or godmother who loves nurturing them", { HC: 2 }),
    o("I'm preparing for or dreaming of motherhood", { HC: 2, WB: 1 }),
    o("Not currently", {}),
  ]},
  { id: "q31", theme: "Goddess Lifestyle", type: "scale", prompt: "How often do you experience pleasure, beauty, wonder, and playfulness in everyday life?", help: "Frequency",
    options: scale(FREQ, { GW: [3, 3, 2, 1, 0], SW: [1, 1, 1, 0, 0] }, { GW: [0, 0, 0, 2, 3] }) },
  { id: "q32", theme: "Goddess Lifestyle", type: "single", prompt: "How do you feel about plants and herbs?", options: [
    o("I'd love to learn which herbs could support my rituals", { HB: 3 }),
    o("I drink herbal teas and want to go deeper", { HB: 2 }),
    o("I already grow or prepare herbs", { HB: 1 }, { HB: 2 }),
    o("They're not my focus right now", {}),
  ]},
  { id: "q33", theme: "Goddess Lifestyle", type: "single", prompt: "When you choose clothing or items for your home, what usually guides you?", options: [
    o("Whatever is fastest or most convenient", { NL: 3, ED: 1 }),
    o("I love beauty, but I haven't been very intentional", { NL: 2, GW: 1, SE: 1 }),
    o("I'm drawn to linen, cotton, and natural materials", { NL: 3 }),
    o("My style and home already reflect my essence", { ED: 1 }, { NL: 2 }),
  ]},
  { id: "q34", theme: "Goddess Lifestyle", type: "scale", prompt: "How consistently do your daily choices honor the life you desire?", help: "Consistency",
    options: scale(FREQ, { ED: [3, 3, 2, 1, 0], EA: [1, 1, 0, 0, 0] }, { ED: [0, 0, 0, 2, 3] }) },
  { id: "q35", theme: "Goddess Lifestyle", type: "scale", prompt: "How often do you give yourself true rest, with nothing to produce?", help: "Frequency",
    options: scale(FREQ_POS, { RN: [3, 3, 2, 1, 0], DF: [1, 1, 0, 0, 0] }, { RN: [0, 0, 0, 2, 3] }) },
  { id: "q36", theme: "Right Now", type: "multi", max: 3, prompt: "Which of these feel true for you right now?", help: "Choose up to three.", options: [
    o("I feel stretched thin", { EM: 2, RN: 2 }, {}, ["overwhelm"]),
    o("I struggle to say no", { PR: 2, DF: 1 }, {}, ["lowBoundaries"]),
    o("I feel spiritually open, but unprotected", { PR: 3 }, {}, ["lowBoundaries"]),
    o("I know what I want, but I don't act on it", { EA: 3 }, {}, ["intentNoAction"]),
    o("I doubt I deserve what I desire", { ID: 3 }, {}, ["limitingBeliefs"]),
    o("My home feels cluttered or uninspiring", { SE: 2, NL: 1 }, {}, ["unsupportiveLifestyle"]),
    o("I've forgotten how to play", { GW: 3 }),
    o("I feel disconnected from my body", { EM: 2, FM: 2 }, {}, ["disconnected"]),
    o("None of these feel true right now", {}),
  ]},
  { id: "q37", theme: "Your Next Season", type: "single", prompt: "What feels most important for your next season of expansion?", help: "Your personal priority.", options: [
    o("Healing, feeling safe, and coming home to my body", { EM: 3, DF: 1, WB: 1 }),
    o("Awakening my feminine energy, womb, and pleasure", { WB: 2, DF: 2, SW: 2 }),
    o("Strengthening my intuition and spiritual gifts", { IN: 2, GF: 2, PR: 1 }),
    o("Learning magick, ritual, and sacred ceremony", { CM: 3, PR: 1 }, {}, ["wantsAdvanced"]),
    o("Transforming my identity and creating my reality", { ID: 2, CE: 1, GC: 2, EA: 1 }),
    o("Living a beautiful, nourishing, high-frequency daily life", { RR: 2, ED: 2, SE: 1, HC: 1 }),
  ]},
];
